import PropTypes from 'prop-types';
import React from 'react';

import I18n from 'utils/I18n';
import PdpConfig from 'utils/PdpConfig';
import Settings from 'utils/Settings';

import { ErrorBoundary } from './ErrorBoundary';

const PdpReviewsContent = ({ className, dataTestId }) => {
  const { currency, yotpoReviewsInstanceId } = Settings;
  const {
    description,
    featuredImageSrc,
    formattedPrice,
    masterName,
    reviewsProductId,
    reviewsProductUrl,
  } = PdpConfig;

  return (
    <div className={className} {...(dataTestId && { 'data-testid': dataTestId })}>
      <p className="mb-3 text-center text-2xl font-bold md:text-3xl">
        {I18n.localize('reviews.overview.productHeading', { productName: masterName })}
      </p>
      <div
        id="yotpo-reviews"
        className="yotpo-widget-instance"
        data-yotpo-currency={currency}
        data-yotpo-description={description}
        data-yotpo-image-url={featuredImageSrc}
        data-yotpo-instance-id={yotpoReviewsInstanceId}
        data-yotpo-name={masterName}
        data-yotpo-price={formattedPrice}
        data-yotpo-product-id={reviewsProductId}
        data-yotpo-url={reviewsProductUrl}
      />
    </div>
  );
};

PdpReviewsContent.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

const PdpReviews = props => (
  <ErrorBoundary>
    <PdpReviewsContent {...props} />
  </ErrorBoundary>
);

PdpReviews.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

export { PdpReviewsContent };
export default PdpReviews;
